// Version 1.2 2021-12-20


export default class FirebaseVersion {
   static getVersion(){
       return 8;
   }
}